import { useRouter, Link } from "@tanstack/react-router";

export function PromoBanner() {
  const router = useRouter();
  const pathname = router.state.location.pathname;
  const isVi = pathname === "/vi" || pathname.startsWith("/vi/");
  const pricingHref = isVi ? "/vi/pricing" : "/pricing";
  const isPricing = pathname === "/pricing" || pathname === "/vi/pricing";

  const t = isVi
    ? {
        limited: "Có hạn",
        mobileHeadline: "Giảm 50% năm đầu",
        mobileCta: "Dùng thử 14 ngày",
        desktopBody: "GIẢM 50% năm đầu tiên — tự động áp dụng khi thanh toán.",
        desktopCta: "Dùng thử miễn phí 14 ngày",
      }
    : {
        limited: "Limited time",
        mobileHeadline: "50% Off First Year",
        mobileCta: "14 Days Free",
        desktopBody: "50% OFF your first year — applied automatically at checkout.",
        desktopCta: "14 Days Free Trial",
      };

  return (
    <div className="bg-foreground text-background">
      {/* Desktop only */}
      <div className="mx-auto hidden max-w-6xl flex-col items-center justify-center gap-1.5 px-4 py-2.5 text-center text-xs font-bold sm:flex sm:flex-row sm:gap-2 md:px-6 md:text-sm">
        <span className="inline-flex shrink-0 items-center gap-1 rounded-full bg-brand-lime px-2 py-0.5 text-[10px] font-extrabold uppercase tracking-wider text-brand-lime-foreground">
          {t.limited}
        </span>
        <span className="min-w-0">{t.desktopBody}</span>
        {!isPricing && (
          <Link
            to={pricingHref}
            className="inline-flex shrink-0 items-center rounded-full bg-background px-2.5 py-1 text-[10px] font-extrabold uppercase tracking-wider text-foreground hover:opacity-90 sm:ml-2"
          >
            {t.desktopCta}
          </Link>
        )}
      </div>
    </div>
  );
}
